import { useState } from 'react';
import { MATERIAL_ICON_ADD } from '../../../shared/common/Button/Icon';
import { Button, ButtonSize, ButtonTheme } from '../../../shared/common/Button';
import { UseMutateFunction } from '@tanstack/react-query';
import { ProductMetaData } from '../../../../models/Product';
import { AdditionalLibxProps } from '../productdetail/api/fetchLibxProduct';
import { Article } from '../../../../models/Article';
import { ProductOut } from '../../../store/apiLibx';
import { useTranslation } from 'react-i18next';

interface Props {
    onAddToCollection: UseMutateFunction<void, unknown, string, unknown> | undefined;
    product: ((ProductMetaData & Article) & AdditionalLibxProps) | ProductOut;
    fullWidth?: boolean;
    size?: ButtonSize;
    theme?: ButtonTheme;
    className?: string;
}

const LibxAddToCollectionButton = ({
    className,
    onAddToCollection,
    product,
    fullWidth,
    size = ButtonSize.SMALL,
    theme = ButtonTheme.NEUTRAL
}: Props) => {
    const [isLoading, setIsLoading] = useState(false);
    const isAlreadyInCollection = product.alreadyInCollection;
    const { t } = useTranslation();

    const labelText = isAlreadyInCollection ? t('shop.orders.addedToCollection') : t('shop.orders.alreadyInCollection');

    return product.alreadyInCollection ? (
        <div className={className}>
            <strong>{labelText}</strong>
        </div>
    ) : (
        <Button
            className={className}
            icon={MATERIAL_ICON_ADD}
            text={t('shop.orders.addToCollection')}
            onClick={() => {
                if (onAddToCollection) {
                    setIsLoading(true);
                    onAddToCollection(product.id!, {
                        onSuccess: () => setIsLoading(false),
                        onError: () => setIsLoading(false)
                    });
                }
            }}
            fullWidth={fullWidth}
            isLoading={isLoading}
            size={size}
            theme={theme}
        />
    );
};

export default LibxAddToCollectionButton;
